import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VueImg from "v-img";
import "font-awesome/css/font-awesome.min.css";
import VueYoutube from "vue-youtube";
import BackToTop from "vue-backtotop";

Vue.config.productionTip = false;

Vue.use(VueYoutube);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueImg);
Vue.use(BackToTop);

Vue.component(
  "VueFontawesome",
  require("vue-fontawesome-icon/VueFontawesome.vue").default
);

new Vue({
  router,
  render: h => h(App),
}).$mount("#app");
